// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  validationId: __t.u64().primaryKey().name("validation_id"),
  jobId: __t.u64().name("job_id"),
  buildId: __t.u64().name("build_id"),
  capsManifest: __t.string().name("caps_manifest"),
  lintReport: __t.string().name("lint_report"),
  typeReport: __t.string().name("type_report"),
  passed: __t.bool(),
  at: __t.timestamp(),
});
